module.exports = __webpack_public_path__ + "04_mole.901dc841.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer2/04_mole.png
// module id = G6Xz
// module chunks = 0